import styled from "styled-components";

export const StickyContainer = styled("div")(({ theme }) => ({
  position: "sticky",
  top: 100,
  width: 350,

  [theme.down("xl")]: {
    width: 300,
  },

  [theme.down("lg")]: {
    width: "100%",
    position: "relative",
    top: 0,
  },
}));

export const Wrapper = styled("div")(({ theme }) => ({
  ...theme.mixins.flexColumn,
  ...theme.paddings(24),
  gap: 10,
  backgroundColor: theme.palette.white,
  boxShadow: `0 2px 8px ${theme.palette.shadowSm}`,
  borderRadius: "8px",
  border: `1px solid ${theme.palette.bgAlt}`,

  [theme.down("lg")]: {
    marginBottom: 80,
  },
}));

export const Header = styled("div")(({ theme }) => ({
  padding: "20px 10px",
  borderBottom: `1px solid ${theme.palette.borderLight}`,
}));

export const Title = styled("h4")(({ theme, $isSmallText }) => ({
  fontSize: "16px",
  fontWeight: "600",
  color: theme.palette.textPrimary,
}));

export const PriceItem = styled("div")(({ theme, $isSmallText }) => ({
  ...theme.mixins.flexCenterBetween,
  fontSize: $isSmallText ? 14 : 18,
  color: theme.palette.textSecondary,

  "& > .price__footer": {
    fontSize: "15px",
    fontWeight: "600",
    color: theme.palette.textPrimary,
  },

  "& > .total__amount": {
    fontSize: "24px",
    fontWeight: "700",
    color: theme.palette.primaryLight,
    letterSpacing: "-0.5px",
  },

  [theme.down("md")]: {
    "& > .total__amount": {
      fontSize: "22px",
    },
  },

  [theme.down("sm")]: {
    fontSize: $isSmallText ? 12 : 15,

    "& > .price__footer": {
      fontSize: "14px",
    },

    "& > .total__amount": {
      fontSize: "18px",
    },
  },

  [theme.down("xs")]: {
    fontSize: $isSmallText ? 11 : 13,

    "& > .price__footer": {
      fontSize: "13px",
    },

    "& > .total__amount": {
      fontSize: "16px",
    },
  },
}));

export const LineDivider = styled("div")(({ theme }) => ({
  width: "100%",
  height: 1,
  backgroundColor: theme.palette.borderLight,
  margin: "8px 0",
}));

export const InfoIcon = styled("span")(({ theme }) => ({
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  width: 16,
  height: 16,
  borderRadius: "50%",
  backgroundColor: theme.palette.borderLight,
  color: theme.palette.textSecondary,
  fontSize: 12,
  fontWeight: 600,
  marginLeft: 4,
  cursor: "help",
  transition: "all 0.2s ease",

  "&:hover": {
    backgroundColor: theme.palette.primaryLight,
    color: theme.palette.white,
  },
}));
